/**
 * Cury (Diffuser) device action preparations.
 * Duplicated from Scenes for Flow independence.
 */

import type { DeviceActionContext, PreparedDeviceAction } from '../types';
import type { DeviceAction } from 'src/types/DeviceActionUI';

const resolveSlotKey = (slot: DeviceAction['slot'], leftKey: string, rightKey: string) =>
	slot === 'left' ? leftKey : rightKey;

enum CuryActionName {
	Intensity = 'cury_intensity',
	Ambient = 'cury_ambient',
	On = 'cury_on',
	Boost = 'cury_boost',
	Stop = 'cury_stop',
}

const CURY_SUPPORTED_ACTIONS = Object.values(CuryActionName) as readonly CuryActionName[];

export const prepareCuryAction = (context: DeviceActionContext): PreparedDeviceAction | null => {
	const { hexToDecimal, actions } = context;
	const _action_el = actions[0];
	const maybeActionName = _action_el?.name as CuryActionName | undefined;

	if (!maybeActionName || !CURY_SUPPORTED_ACTIONS.includes(maybeActionName)) {
		return null;
	}

	switch (maybeActionName) {
		case CuryActionName.Intensity: {
			const slotKey = resolveSlotKey(_action_el?.slot, 'cil', 'cir');
			return {
				_gui_purpose: 'action',
				r: `dev:${hexToDecimal}:${slotKey}`,
				set: _action_el.value,
			};
		}
		case CuryActionName.Ambient: {
			const ambientValue = _action_el.value as Record<string, unknown>;
			return {
				_gui_purpose: 'action',
				r: `dev:${hexToDecimal}:ca`,
				set: {
					_isdata: true,
					enable: ambientValue.enable,
					brightness: ambientValue.brightness,
					red: ambientValue.red,
					green: ambientValue.green,
					blue: ambientValue.blue,
				},
			};
		}
		case CuryActionName.On: {
			const slotKey = resolveSlotKey(_action_el?.slot, 'onl', 'onr');
			return {
				_gui_purpose: 'action',
				r: `dev:${hexToDecimal}:${slotKey}`,
				set: _action_el.value,
			};
		}
		case CuryActionName.Boost: {
			const slotKey = resolveSlotKey(_action_el?.slot, 'bl', 'br');
			return {
				_gui_purpose: 'action',
				r: `dev:${hexToDecimal}:${slotKey}`,
				set: _action_el.value,
			};
		}
		case CuryActionName.Stop: {
			const slotKey = resolveSlotKey(_action_el?.slot, 'bl', 'br');
			return {
				_gui_purpose: 'action',
				r: `dev:${hexToDecimal}:${slotKey}`,
				set: false,
			};
		}
		default:
			return null;
	}
};
